import { notThumbEmbroidery, thumbEmbroidery } from 'src/features/gorilla/drawer/common/back/embroidery'
import { Embroidery } from 'src/types'

export const fingerEmbroideryDrawer = (ctx: CanvasRenderingContext2D, embroideries: Embroidery[]): void => {
  // 親指への刺繍
  const isEmbroideryOfThumb = embroideries.some((x) => x.position.value === 'thumbFinger')
  if (isEmbroideryOfThumb) {
    thumbEmbroidery(
      ctx,
      embroideries.find((embroidery) => embroidery.position.value === 'thumbFinger'),
      -20,
      20,
      -5
    )
  }
  // 小指への刺繍
  const isEmbroideryOfChild = embroideries.some((x) => x.position.value === 'childFinger')
  if (isEmbroideryOfChild) {
    notThumbEmbroidery(
      ctx,
      embroideries.find((embroidery) => embroidery.position.value === 'childFinger'),
      80,
      25,
      -5
    )
  }
}
